export default __webpack_public_path__ + "static/media/IMG_20230304_184310 - Rahul Siloniya.ffb2ca11.jpg";